import * as React from "react";
import PropTypes from "prop-types";
import ButtonGroup from "nx-components/ButtonGroup";

const wrapperStyle = {
  fontSize: "0.8em",
  width: "100%",
};

const DeviceControlButtonGroup = ({ children }) => (
  <div style={wrapperStyle}>
    <ButtonGroup>{children}</ButtonGroup>
  </div>
);

DeviceControlButtonGroup.propTypes = {
  children: PropTypes.node,
};

export default DeviceControlButtonGroup;



// WEBPACK FOOTER //
// ./src/components/Controls/DeviceControlButtonGroup.jsx